import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
import { DialogContentText } from '@mui/material';
// function PaperComponent({ ...props }) {
//     return (
//         <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
//             <Paper {...props} />
//         </Draggable>
//     );
// }

export default function ConfirmModal({
    isExpTime = false,
    visible = false,
    setVisible,
    handleConfirm,
    loader,
    title,
    mesages,
}) {
    const { t } = useTranslation();

    return (
        <div>
            <Dialog
                open={visible}
                // closeAfterTransition
                // hideBackdrop
                BackdropProps={{ onClick: null }}
                // onClose={() => setVisible(false)}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {t('notify')}
                </DialogTitle>
                <DialogContent>
                    {/* <Alert sx={{ alignItems: 'flex-start' }} severity="warning">
                        <div>
                            <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                                {t('note')}
                            </Typography>
                            <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                                {t('action_success')}
                                <b>{t('action_success')} </b>
                                {t('action_warning')}
                            </Typography>
                        </div>
                    </Alert> */}
                    <DialogContentText>{!isExpTime ? t('notify_logout') : t('warning_idel_time')}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    {!isExpTime ? (
                        <>
                            <ButtonAction title={t('cancel')} onClick={() => setVisible(false)} type="cancel" />
                            <ButtonAction title={t('comfirm')} type="confirm" onClick={handleConfirm} />
                        </>
                    ) : (
                        <ButtonAction title={t('ok')} type="confirm" onClick={handleConfirm} />
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
}
